import { Component, OnInit, Inject, HostListener, DOCUMENT } from '@angular/core';


@Component({
    selector: 'app-scroll-top',
    templateUrl: './scroll-top.component.html',
    styleUrls: ['./scroll-top.component.scss'],
    standalone: false
})
export class ScrollTopComponent implements OnInit {
  windowScrolled: boolean;
  topOffset: number = 150; // Top offset to display scroll to top button

  constructor(@Inject(DOCUMENT) private document: Document) {}

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (
      window.pageYOffset > this.topOffset ||
      document.documentElement.scrollTop > this.topOffset ||
      document.body.scrollTop > this.topOffset
    ) {
      this.windowScrolled = true;
    } else if (
      (this.windowScrolled && window.pageYOffset) ||
      document.documentElement.scrollTop ||
      document.body.scrollTop < 10
    ) {
      this.windowScrolled = false;
    }
  }

  scrollToTop() {
    // El scroll suave lo resuelve el navegador: la animación manual restaba
    // una fracción del offset, nunca llegaba a 0 y el rAF quedaba vivo
    // reposicionando la página en cada frame (impedía volver a bajar).
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  ngOnInit() {}
}
